import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="pt-20 flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
        <div className="w-20 h-20 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 mb-6">
          <i className="ri-emotion-sad-line text-3xl"></i>
        </div>
        <h1 className="font-heading text-3xl font-semibold text-foreground-900 mb-3">页面不存在</h1>
        <p className="text-foreground-500 mb-6 max-w-md">
          你访问的页面可能已被移除或地址有误，请检查后重试。
        </p>
        <Link
          to="/"
          className="px-6 py-2.5 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          返回首页
        </Link>
      </div>
      <Footer />
    </div>
  );
}